var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-app-search",
      attrs: { id: "form-search-popover" }
    },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized }
        },
        [
          _c("h4", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("DATA MANAGER")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "custom-search d-flex",
              attrs: { slot: "beforeFilter" },
              slot: "beforeFilter"
            },
            [
              _vm.isAdmin
                ? _c(
                    "b-button",
                    {
                      staticClass: "btn grey btn-import-form m__r--5",
                      on: {
                        click: function($event) {
                          _vm.$refs.modalAdd.show()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus fa-lg" }),
                      _vm._v(" Add\n      ")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("b-form-input", {
                staticStyle: { width: "250px", height: "35px" },
                attrs: { placeholder: "Search Table Group" },
                model: {
                  value: _vm.filter_data,
                  callback: function($$v) {
                    _vm.filter_data = $$v
                  },
                  expression: "filter_data"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "studio-page-content" },
        [
          _c("h4", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("TABLE GROUP")
          ]),
          _vm._v(" "),
          _vm.showContainerGroup
            ? _c(
                "div",
                { staticClass: "row-group-studio" },
                _vm._l(_vm.listGroup, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "col-group-studio" },
                    [
                      _c("div", { staticClass: "data-group-container" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/icon-sidebar/data-manager.svg"),
                                width: "35"
                              },
                              on: {
                                click: function($event) {
                                  _vm.openDetail(item.id)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "data-group-container__label ellipsis",
                                on: {
                                  click: function($event) {
                                    _vm.openDetail(item.id)
                                  }
                                }
                              },
                              [
                                item.id === "legacy"
                                  ? _c("i", [_vm._v(_vm._s(item.name))])
                                  : _c("b", [_vm._v(_vm._s(item.name))]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "data-group-container__label-small"
                                  },
                                  [
                                    _vm._v(
                                      "\n                Last edit at " +
                                        _vm._s(
                                          _vm.convertDateTime(item.updated_at)
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            item.id !== "legacy"
                              ? _c("i", {
                                  staticClass:
                                    "fa fa-ellipsis-v fa-lg data-group-container__icon-config",
                                  attrs: { id: "configPopover-" + item.id },
                                  on: {
                                    click: function($event) {
                                      _vm.showPopoverComponent(item.id)
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.popoverSelected === item.id
                              ? _c(
                                  "b-popover",
                                  {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.hideAllPopover,
                                        expression: "hideAllPopover"
                                      }
                                    ],
                                    attrs: {
                                      target: "configPopover-" + item.id,
                                      show: _vm.showPopover,
                                      triggers: "click blur",
                                      placement: "bottom"
                                    },
                                    on: {
                                      "update:show": function($event) {
                                        _vm.showPopover = $event
                                      }
                                    }
                                  },
                                  [
                                    _vm.showContentPopover
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "add-automation",
                                            class: {
                                              disabled: _vm.isDisabledConfig
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.openConfig(item)
                                              }
                                            }
                                          },
                                          [_vm._v("Configuration")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isAdmin && _vm.showContentPopover
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "add-automation",
                                            on: {
                                              click: function($event) {
                                                _vm.deleteData(item)
                                              }
                                            }
                                          },
                                          [_vm._v("Delete")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.showContentPopover
                                      ? _c("div", [_vm._v("Please wait...")])
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "data-group-container__count-dataset",
                            on: {
                              click: function($event) {
                                _vm.openDetail(item.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.total_table || 0) +
                                "\n            "
                            ),
                            _c("small", [
                              _vm._v(
                                "table" +
                                  _vm._s(item.total_table > 0 ? "s" : "")
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                })
              )
            : _c(
                "b-row",
                { staticClass: "data-group-wrap-loading" },
                _vm._l(8, function(i) {
                  return _c(
                    "b-col",
                    { key: i, attrs: { xl: "3", lg: "4", md: "4", sm: "6" } },
                    [_c("div", { staticClass: "group-block" })]
                  )
                })
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalAdd",
          staticClass: "mod-form modal-form-ui",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c("div", { staticClass: "label-group-modal text-center" }, [
            _vm._v("CREATE TABLE GROUP")
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.table_group_name.$error } },
            [
              _c("label", { attrs: { for: "name" } }, [_vm._v(" Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  id: "name",
                  placeholder:
                    "Only lowercase characters and underscore '_' are allowed, ex: name_group"
                },
                model: {
                  value: _vm.$v.table_group_name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.table_group_name, "$model", $$v)
                  },
                  expression: "$v.table_group_name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "float-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn white m__r--5",
                  on: { click: _vm.closeModal }
                },
                [_vm._v("\n        Close\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { staticClass: "btn blue", on: { click: _vm.submitData } },
                [_vm._v("\n        Create\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4443714c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4443714c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jFormGroup.vue
// module id = null
// module chunks = 